import { render, staticRenderFns } from "./UsersWithoutRequestsModal.vue?vue&type=template&id=65b0e492&"
import script from "./UsersWithoutRequestsModal.vue?vue&type=script&lang=js&"
export * from "./UsersWithoutRequestsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UsersWithoutRequestsModal.vue"
export default component.exports